<template>
  <div class="collapsible-panel">
    <div class="collapsible-panel-head" @click="toggle">
      <div class="collapsible-panel-head-line" :class="{ 'is-open': isOpen, 'collapsible-panel-head-line-inside': isInsidePanel }">
        <slot name="headline" />
      </div>
      <div class="collapsible-panel-toggle" :class="{ 'is-open': isOpen, 'collapsible-panel-toggle-inside': isInsidePanel }">
        <font-awesome-icon icon="chevron-down" class="toggle-icon" />
      </div>
    </div>
    <div class="collapsible-panel-body" :class="{ 'is-open': isOpen, 'collapsible-panel-body-inside': isInsidePanel }">
      <slot name="body" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapsiblePanel',
  props: {
    initialIsOpen: {
      type: Boolean,
      default: false,
    },
    isInsidePanel: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  mounted() {
    this.$nextTick(() => (this.isOpen = this.initialIsOpen));
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style scoped lang="scss">
.collapsible-panel {
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 20px;
  margin-top: 20px;

  &-head {
    height: 68px;
    display: flex;
    align-items: center;
    position: relative;

    &-line {
      font-size: 1.25rem;
      margin-left: 27px;
      color: #454f63;
    }
  }

  &-toggle {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    border: 1px solid #1db2d1;
    position: absolute;
    top: 24px;
    right: 20px;
    color: #1db2d1;
    font-size: 11px;
    transition: all 200ms ease-in-out;

    &.is-open {
      transform: rotate(-180deg);
    }
  }

  &-head-line-inside {
    margin-left: 0;
  }

  &-toggle-inside {
    right: 0px;
  }


  &-body {
    border-top: 1px solid #f4f4f6;
    padding: 0 20px;
    display: none;

    &.is-open {
      display: block;
    }
  }

  &-body-inside {
    padding: 0;
  }
}
</style>
